import { Navigate, useLocation, useParams } from "react-router-dom";

/** Thay `:tham-số` trong đích bằng giá trị thật, giữ nguyên `?query`. */
export function LegacyRedirect({ to }: { to: string }) {
  const params = useParams();
  const { search } = useLocation();
  const target = to.replace(/:([A-Za-z]+)/g, (_, k: string) => encodeURIComponent(params[k] ?? ""));
  return <Navigate to={`${target}${search}`} replace />;
}
